// Admin

import { FaProductHunt } from "react-icons/fa";
import { MdCategory } from "react-icons/md";

// Deny access to staff (3) and customer (4) roles
const adminPermissions = { userRoles: { denied: [3, 4] } };

const ADMIN = {
	"/admin/products": {
		id: "/admin/products",
		title: "Manage Products",
		type: "single",
		icon: FaProductHunt,
		url: "/admin/products",
		disabled: false,
		permissions: adminPermissions,
	},
	"/admin/categories": {
		id: "/admin/categories",
		title: "Manage Categories",
		type: "single",
		icon: MdCategory,
		url: "/admin/categories",
		disabled: false,
		permissions: adminPermissions,
	},
};

export default ADMIN;
